<script setup lang="ts">
import { defaultLinkValues } from '~/layers/cms/app/types/cmsTypes'
import type { CmsData, CmsLink } from '~/layers/cms/app/types/cmsTypes'
import Button from 'primevue/button'
import InputText from 'primevue/inputtext'
import Select from 'primevue/select'
import { inject, onMounted, ref } from 'vue'
import { getcurrentChosenElement, update_cms_values } from '~/layers/cms/app/plugins/cms-link-element'
import { useChoosePage } from '~/layers/cms/app/composables/choosePage'
import { getByPath, setByPath } from '~/layers/cms/app/utils/cmsDataHelper'
import { useState } from '#app'
import type Textarea from 'primevue/textarea'
import { useChooseFile } from '#imports'

const cmsData = useState<CmsData>('cmsData')

const dialogRef = inject<DialogRef>('dialogRef')
interface DialogRef {
  value: {
    close(): void
  }
}

const closeDialog = () => {
  if (!dialogRef) return
  dialogRef.value.close()
}

const cms_link = ref<CmsLink>(defaultLinkValues)
const cms_data_path = ref<string[]>([])

const loadElementData = () => {
  const element = getcurrentChosenElement()
  if (!element) {
    closeDialog()
    return
  }
  cms_data_path.value = element
  cms_link.value = { ...defaultLinkValues, ...getByPath(cmsData.value, cms_data_path.value)?.component_data } as CmsLink
}

onMounted(() => {
  loadElementData()
})

const updateLink = () => {
  setByPath(cmsData.value, [...cms_data_path.value, 'component_data'], cms_link.value)
  update_cms_values(cms_link.value)
  closeDialog()
}

const { choosePage } = useChoosePage()

const chooseLinkFromSites = async () => {
  const newSrc = await choosePage()
  if (newSrc) {
    cms_link.value.href = newSrc
  }
}

const { chooseFile } = useChooseFile()
const selectFile = async () => {
  const newSrc = await chooseFile()
  if (newSrc) {
    cms_link.value.href = newSrc
  }
}
</script>

<template>
  <div class="flex flex-col gap-4">
    <div class="flex items-center gap-4">
      <label
        for="input-href"
        class="w-24 font-semibold"
      >Href</label>
      <InputText
        id="input-href"
        v-model="cms_link.href"
        class="flex-auto"
        autocomplete="off"
      />
      <Button
        type="button"
        label="Wybierz z listy stron"
        severity="secondary"
        @click="chooseLinkFromSites"
      />
      <Button
        type="button"
        label="Wybierz z listy plików"
        severity="secondary"
        @click="selectFile"
      />
    </div>

    <div class="flex items-center gap-4">
      <label
        for="input-text"
        class="w-24 font-semibold"
      >Link text</label>
      <Textarea
        v-model="cms_link.link_text"
        class="flex-auto"
        autocomplete="off"
      />
    </div>

    <div class="flex items-center gap-4">
      <label
        for="input-target"
        class="w-24 font-semibold"
      >Target</label>
      <Select
        id="input-target"
        v-model="cms_link.target"
        class="flex-auto"
        :options="['_self', '_blank', '_parent', '_top']"
      />
    </div>

    <div class="flex items-center gap-4">
      <label
        for="input-rel"
        class="w-24 font-semibold"
      >Rel</label>
      <Select
        id="input-rel"
        v-model="cms_link.rel"
        class="flex-auto"
        :options="['noopener noreferrer', 'noopener', 'noreferrer', 'nofollow']"
        placeholder="opcjonalne"
        show-clear
      />
    </div>

    <div class="flex items-center gap-4">
      <label
        for="input-aria-label"
        class="w-24 font-semibold"
      >Aria label</label>
      <InputText
        id="input-aria-label"
        v-model="cms_link.aria_label"
        class="flex-auto"
        autocomplete="off"
        placeholder="opcjonalne"
      />
    </div>

    <div class="flex justify-end gap-2">
      <Button
        type="button"
        label="Cancel"
        severity="secondary"
        @click="closeDialog"
      />
      <Button
        type="button"
        label="Save"
        @click="updateLink"
      />
    </div>
  </div>
</template>
